import { render, staticRenderFns } from "./StickyMenuBar.vue?vue&type=template&id=387f6cb9&"
import script from "./StickyMenuBar.vue?vue&type=script&lang=js&"
export * from "./StickyMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./StickyMenuBar.vue?vue&type=style&index=0&id=387f6cb9&prod&lang=sass&rel=stylesheet%2Fsass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports